export const APP_VERSION = `v${__APP_VERSION__}`;
export const SUPPORT_EMAIL = "support@compbox.io";
